import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { IonicModule, LoadingController, ModalController, NavParams as Nav, Platform, ToastController, AlertController } from '@ionic/angular';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';
import { UserProvider } from './services/user/user';
import { map } from 'rxjs/operators'
import { FormGeradorPage } from './pages/form-gerador/form-gerador.page';
import { Router } from '@angular/router';
import { SplashScreen } from '@capacitor/splash-screen';
import { IonRouterOutlet } from '@ionic/angular/standalone';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  ActionPerformed,
  PushNotifications,
} from '@capacitor/push-notifications';
import { ContribuaPage } from './pages/contribua/contribua.page';
import { NoticiaDetalhesPage } from './components/noticia-detalhes/noticia-detalhes.page';
import { AniversariantesPage } from './pages/aniversariantes/aniversariantes.page';
import { AcompanhamentoPage } from './pages/acompanhamento/acompanhamento.page';
import { EnqueteListaPage } from './pages/enquete-lista/enquete-lista.page';
import { EventoDetalhesPage } from './pages/evento/evento-detalhes/evento-detalhes.page';
import { OracaoAdmPage } from './pages/oracao/oracao-adm/oracao-adm.page';
import { OracaoPage } from './pages/oracao/oracao.page';
import { MensagemDetailPage } from './pages/mensagem/mensagem-detail/mensagem-detail.page';
import { MdaDetalhesPage } from './pages/mda/mda-detalhes/mda-detalhes.page';
import { GrupoDetalhesPage } from './pages/grupo/grupo-detalhes/grupo-detalhes.page';
import { CultoDetalhesPage } from './pages/culto/culto-detalhes/culto-detalhes.page';
import { Capacitor, registerPlugin } from '@capacitor/core';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { AplicativoProvider } from './services/aplicativo/aplicativo';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { Device } from '@capacitor/device';
import { StatusBar, Style } from '@capacitor/status-bar';

declare var instituicaoConstants: { IS_PWA: boolean; LINGUAGEM: string; TOKEN_ANONIMO: any; INSTITUICAO: any; };
declare var browserDefault: ((url?: string | URL | undefined, target?: string | undefined, features?: string | undefined) => Window | null) & ((url?: string | URL | undefined, target?: string | undefined, features?: string | undefined) => Window | null);

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    IonRouterOutlet,
    IonicModule,
    HttpClientModule,
    IonicStorageModule,
    TranslateModule,
    NgCircleProgressModule,
    CommonModule,
  ]
})

export class AppComponent {
  public isPwa: boolean = instituicaoConstants.IS_PWA;
  public linguagem: string = instituicaoConstants.LINGUAGEM ? instituicaoConstants.LINGUAGEM : 'pt';
  @ViewChild(Nav) nav: Nav | undefined;
  rootPage: any = "";
  version: string = '';
  usuario: any = { id: 0, nome: '', foto: '', instituicao: {} };
  pages: Array<{ title: string; component: any; icon: string; }> | undefined;
  fcmId: string = '';
  isMessianica = false;

  constructor(
    public platform: Platform,
    public translate: TranslateService,
    public router: Router,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    public loadingController: LoadingController,
    public http: HttpClient,
    private storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public aplicativoProvider: AplicativoProvider,
  ) {
    this.isMessianica = environment.isMessianica;
    this.userProvider.getIdioma();
    this.translate.setDefaultLang(this.linguagem);
    this.translate.use(this.linguagem);
    this.initializeApp();

    if (instituicaoConstants.IS_PWA === true) {
      this.versionamentoBrowser();
    }
  }

  async ngOnInit() {    
    await this.storage.create();
    this.getDarkMode();
  }

  private async enableEdgeToEdge() {
    try {
      if (Capacitor.getPlatform() === 'android') {
        const info = await Device.getInfo();
        if (info.osVersion && parseInt(info.osVersion.split('.')[0], 10) >= 15) {
          await EdgeToEdge.enable();
        }
      }
    } catch (err) {
      console.warn('Falha ao habilitar Edge-to-Edge', err);
    }
  }

  versionamentoBrowser() {
    this.http.get('assets/info/info.json?t=' + new Date().getTime()).pipe(map(res => <any>res)).subscribe(data => {
      this.userProvider.getVersion().then(version => {
        if (!version) {
          this.userProvider.setVersion(data.version);
        } else if (version != data.version) {
          this.userProvider.setVersion(data.version);

          caches.keys().then(keys => {
            keys.forEach(key => caches.delete(key));
          });

          setTimeout(() => document.location.reload(), 2000);
        } else {
          console.log('atualizado:' + version);
        }
      });
    });
  }

  async getDarkMode() {
    await this.storage.get('dark_mode').then(value => {
      value == null ? this.storage.set('dark_mode', false) :
        this.storage.set('dark_mode', value);

      if (value != null) {
        document.body.classList.toggle('dark', value);
      }
      return value;
    });
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      this.enableEdgeToEdge();

      if (Capacitor.isNativePlatform()) {
        this.userProvider.message$.subscribe(() => {
          this.initPushNotification();
        })
      }

      if (instituicaoConstants.TOKEN_ANONIMO) {
        this.storage.set('token', this.userProvider.getToken() ? this.userProvider.getToken() : instituicaoConstants.TOKEN_ANONIMO).then(data => {
          this.userProvider.atualizarDadosPessoa().subscribe(data => {
            this.router.navigate(['tabs']);
          });
        });
      }

      this.userProvider.getDados().then(async res => {
        if (res) {
          if (!res.isAnonimo && Capacitor.isNativePlatform()) {
            this.initPushNotification();
          }
        }

        var url = window.location.href;

        if (url.replace(/.*pc=([^&]*).*|(.*)/, '$1').split('#')[0]) {
          url = url.replace('u=', '&u=');
        }

        var token = url.replace(/.*t=([^&]*).*|(.*)/, '$1').split('#')[0];
        var cadastroToken = url.replace(/.*c=([^&]*).*|(.*)/, '$1').split('#')[0];
        var user = url.replace(/.*u=([^&]*).*|(.*)/, '$1').split('#')[0];
        var idNoticia = url.replace(/.*n=([^&]*).*|(.*)/, '$1').split('#')[0];
        var idPlanoContribuicao = url.replace(/.*pc=([^&]*).*|(.*)/, '$1').split('#')[0];

        if (instituicaoConstants.IS_PWA) {
          window.open = browserDefault;
        }

        this.userProvider.isLoggedin().then(async login => {
          var cadastro: any = {};

          //CADASTRO EXTERNO OVELINHAS
          if (token && instituicaoConstants.IS_PWA && cadastroToken == '0' && (this.userProvider.isAnonimo() || !login)) {
            cadastro.form = 'APP_EXT_OVEL';
            cadastro.idPessoaTipo = 5;
            cadastro.titulo = 'Novo Cadastro';
            cadastro.idInstituicao = token;
            cadastro.encrypt = true;
            cadastro.hideBack = true;
            const modalPage = await this.modalCtrl.create({
              component: FormGeradorPage,
              componentProps: cadastro
            });
            modalPage.present();
          }
          //CADASTRO EXTERNO
          else if (token && instituicaoConstants.IS_PWA && cadastroToken == '1'
            && (this.userProvider.isAnonimo() || !login)) {
            cadastro.form = 'APP_CAD_INICIO';
            cadastro.idPessoaTipo = 5;
            cadastro.titulo = 'Novo Cadastro';
            cadastro.idInstituicao = token;
            cadastro.encrypt = true;
            cadastro.hideBack = true;
            const modalPage = await this.modalCtrl.create({
              component: FormGeradorPage,
              componentProps: cadastro
            });
            modalPage.present();
          }
          //compartilhamento de contribuicao
          else if (instituicaoConstants.IS_PWA && idPlanoContribuicao && user) {

            this.userProvider.getUserByToken(user).subscribe(usuarioCompartilhamento => {
              // compartilhamento de contribuicao com login
              if (login && !this.userProvider.isAnonimo() && res.instituicao
                && (usuarioCompartilhamento.instituicao.id == res.instituicao.id)) {

                Promise.all([
                  this.storage.set('contribua_hideback', true),
                  this.storage.set('contribua_login', true),
                  this.storage.set('contribua_idPlanoContribuicao', idPlanoContribuicao),
                ]).then(value => window.location.href = window.location.origin + "/#/contribua");

              }
              //compartilhamento de contribuicao sem login
              else {

                this.storage.set('token', user).then(() => {
                  this.userProvider.atualizarDadosPessoa().subscribe(() => {
                    this.translate.setDefaultLang(this.linguagem);

                    Promise.all([
                      this.storage.set('contribua_hideback', true),
                      this.storage.set('contribua_login', false),
                      this.storage.set('contribua_idPlanoContribuicao', idPlanoContribuicao),
                    ]).then(value => window.location.href = window.location.origin + "/#/contribua");

                  });

                });

              }
            });

          }
          //contribuicao vindo do app (clicando em contribua e indo para um PWA)
          else if (user && instituicaoConstants.IS_PWA) {
            this.userProvider.loginByToken(user).subscribe(async (data) => {
              if (!data.error) {
                Promise.all([
                  this.storage.set('contribua_hideback', true),
                  this.storage.set('contribua_login', true),
                  this.storage.set('contribua_idPlanoContribuicao', idPlanoContribuicao),
                ]).then(value => window.location.href = window.location.origin + "/#/contribua");

              } else {
                const toast = await this.toastCtrl.create({
                  message: this.translate.instant(data.message),
                  duration: 3000
                });
                toast.present();
              }

            });
          } else if (res) {
            if (this.checkIsContribua()) {
              const modalPage = await this.modalCtrl.create({
                component: ContribuaPage,
              });
              modalPage.present();
            } else {
              this.router.navigate(['tabs']);
            }

          } else if (!res && instituicaoConstants.TOKEN_ANONIMO) {
            this.storage.set('token', instituicaoConstants.TOKEN_ANONIMO).then(data => {
              this.userProvider.atualizarDadosPessoa().subscribe(data => {
                this.router.navigate(['tabs']);
              });
            });
          } else {
            !login ? 
              this.isMessianica ?
                this.router.navigate(['onboarding']) :
                this.router.navigate(['login'])
            : this.router.navigate(['tabs']);
          }
        });

        window.addEventListener('statusTap', function () {
          console.log('statusbar tapped');
        });
      });

      if (Capacitor.isNativePlatform()) {
        setTimeout(async () => {
          SplashScreen.hide();

          if (Capacitor.getPlatform() === 'ios') {
            await StatusBar.setStyle({ style: Style.Default });
            StatusBar.setOverlaysWebView({ overlay: false });
            StatusBar.show();
          }
        }, 2000);
      }
    });
  }

  getDeliveredNotifications = async () => {
    const notificationList = await PushNotifications.getDeliveredNotifications();
    return notificationList;
  }

  async initPushNotification() {
    PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
      this.tratarPush(notification);
    });

    this.clearIosBadgeAndDelivered();

    let permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive !== 'granted') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive === 'granted') {
      await PushNotifications.register();

      PushNotifications.addListener('registration', token => {
        this.fcmId = token.value;
        const platform = Capacitor.getPlatform() === 'android' ? 'ANDROID' : 'IOS';
        this.userProvider.getDados().then((res) => {
          if (res) {
            this.http.get('assets/info/info.json?t=' + new Date().getTime()).subscribe((data: any) => {
              this.userProvider.setTokenPush(
                this.fcmId,
                platform,
                data.version,
                res.instituicao.id
              ).subscribe();
            });
          }
        });
      });
    }

    PushNotifications.addListener('pushNotificationReceived', notification => {
      const confirm = this.alertCtrl.create({
        header: this.translate.instant('Nova Notificação'),
        subHeader: notification.data.title ? notification.data.title : notification.title,
        message: notification.data.body ? notification.data.body : notification.body,
        buttons: [
          {
            text: this.translate.instant('Ignorar'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('Visualizar'),
            handler: () => {
              this.tratarPush(notification);
            },
          },
        ],
      });

      confirm.then(alert => alert.present());
    });
  }

  async tratarPush(notification: any) {
    const dadosRaw = notification.notification?.data?.dadosApp;
    if (!dadosRaw) return;

    let dados: any;
    try {
      dados = JSON.parse(dadosRaw);
    } catch (e) {
      console.error('Erro ao parsear dadosApp:', e);
      return;
    }

    const entidade = dados.entidade;
    const id = dados.idEntidade;
    const extras = dados.extras || {};

    const abrirModal = async (component: any, props: any = {}) => {
      const modal = await this.modalCtrl.create({ component, componentProps: props });
      await modal.present();
    };

    switch (entidade) {
      case 'noticia':
        await abrirModal(NoticiaDetalhesPage, { id });
        break;

      case 'culto':
        await abrirModal(CultoDetalhesPage, {
          idCulto: id,
          dataInicio: extras.dataInicio,
          idCultoAgenda: 0
        });
        break;

      case 'cultoagenda':
        await abrirModal(CultoDetalhesPage, {
          idCulto: extras.idCulto,
          dataInicio: extras.dataInicio,
          idCultoAgenda: id
        });
        break;

      case 'grupo':
        await abrirModal(GrupoDetalhesPage, { id, tipo: '1', aba: extras.aba });
        break;

      case 'ministerio':
        await abrirModal(GrupoDetalhesPage, { id, tipo: '2', aba: extras.aba });
        break;

      case 'mda':
        await abrirModal(MdaDetalhesPage, { id });
        break;

      case 'mensagem':
        await abrirModal(MensagemDetailPage, { id });
        break;

      case 'oracao':
        await abrirModal(dados.extras?.equipe === '1' ? OracaoAdmPage : OracaoPage);
        break;

      case 'evento':
        await abrirModal(EventoDetalhesPage, { id, tipo: '1' });
        break;

      case 'ensino':
        await abrirModal(EventoDetalhesPage, { id, tipo: '2' });
        break;

      case 'aniversariantes':
        await abrirModal(AniversariantesPage);
        break;

      case 'enquete':
        await abrirModal(EnqueteListaPage, { idEnquete: id });
        break;

      case 'acompanhamento':
        await abrirModal(AcompanhamentoPage);
        break;

      default:
        console.warn(`Entidade desconhecida: ${entidade}`);
    }
  }

  async clearIosBadgeAndDelivered() {
    if (Capacitor.getPlatform() !== 'ios') return;
    if (PushNotifications.removeAllDeliveredNotifications) {
      await PushNotifications.removeAllDeliveredNotifications();
    }
  }

  checkIsContribua() {
    const params = window.location.href.split('/#/');
    const url = params[params.length - 1];
    if (url && url == 'contribua') {
      return true;
    }
  }
}
